var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "commment-wrapper",
      attrs: { id: "tenant-submission-comments" },
    },
    [
      [
        _vm.hasPendingSubmission
          ? _c("div", { staticClass: "batch-label" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("tenantProjects.tenantViewComments.batchNumber", [
                    _vm.currentTenantSubmission
                      ? _vm.currentTenantSubmission.order + 1
                      : 1,
                  ])
                )
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isReinstatementPoject
          ? _c("DesignComment", {
              ref: "designComments",
              attrs: { canComment: _vm.canCommentDesign },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.isReinstatementPoject
          ? _c("hr", { attrs: { align: "center" } })
          : _vm._e(),
        _vm._v(" "),
        _c("TechComments", { ref: "techComments" }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isReviewer || _vm.files.length > 0,
                expression: "isReviewer || files.length > 0",
              },
            ],
            staticClass: "file-attachments",
          },
          [
            _vm.isReviewer
              ? _c("HkldDropzone", {
                  attrs: {
                    sourceId:
                      ((_vm.canCommentDesign || _vm.canCommentTech) &&
                        _vm.currentTenantSubmission &&
                        _vm.currentTenantSubmission.id) ||
                      "",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activeSubmission
              ? _c("TenantSubmissionDocuments", {
                  attrs: {
                    files: _vm.files,
                    canEdit: _vm.isReviewer,
                    sourceId:
                      (_vm.currentTenantSubmission &&
                        _vm.currentTenantSubmission.id) ||
                      "",
                  },
                  on: {
                    "update:files": function ($event) {
                      _vm.files = $event
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
      _vm._v(" "),
      _c("CommentsView"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }